'use client';

import { useEffect, useRef } from 'react';

// くじ専用のページビューをGAに送信
function SendGALotteryView({
  age,
  gender,
  lotteryId,
}: {
  age: number;
  gender: string;
  lotteryId: number;
}) {
  const sendingRef = useRef(false);
  useEffect(() => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (window as any).dataLayer = (window as any).dataLayer || [];
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const dataLayer = (window as any).dataLayer;
    // カスタムイベント
    dataLayer.push({
      event: 'lottery_page_view',
      age: age,
      gender: gender,
      lotteryId: lotteryId,
    });
  }, []);
  return <></>;
}

export default SendGALotteryView;
